import {
  // Notifications
  LuBell,
  LuBellRing,
  LuBellDot,
  LuMessageSquare,
  LuMessageSquareCode,
  LuMessageCircle,
  LuMessageCircleMore,
  LuMail,
  LuMailOpen,
  LuMailbox,
  LuPhone,
  LuVideo,
  LuRss,
  
  // Documents / Files
  LuBookOpen,
  LuFile,
  LuFileText,
  LuFileArchive,
  LuFileAudio,
  LuFileCode,
  LuFileCode2,
  LuFileSpreadsheet,
  LuFileWarning,
  LuFileX,
  LuFolderOpen,
  LuFolderArchive,
  LuFolderCheck,
  LuFolderClock,
  LuFolderClosed,
  LuFolderCog,
  LuFolderDot,
  LuFolderDown,
  LuFolderGit,
  LuFolderHeart,
  LuFolderInput,
  LuFolderKey,
  LuFolderLock,
  LuFolderMinus,
  LuFolderOutput,
  LuFolderPen,
  LuFolderPlus,
  LuFolderRoot,
  LuFolderSearch,
  LuFolderSymlink,
  LuFolderSync,
  LuFolderTree,
  LuFolderUp,
  LuFolderX,
  LuClipboardCheck,
  LuClipboardList,
  LuDownload,
  LuUpload,
  LuNewspaper,
  LuImage,
  LuSignature,
  LuFileSignature, // Note: We keep this commented or omitted if not present, let's omit it since it was not found

  // Business / Finance
  LuCreditCard,
  LuWallet,
  LuReceipt,
  LuBriefcase,
  LuBriefcaseBusiness,
  LuBriefcaseMedical,
  LuBuilding,
  LuBuilding2,
  LuLandmark,
  LuTrendingUp,
  LuTrendingDown,
  LuBadgeDollarSign,
  LuBadgePercent,
  LuBanknote,
  LuCoins,
  LuDollarSign,
  LuEuro,
  LuIndianRupee,
  LuJapaneseYen,
  LuPoundSterling,
  LuRussianRuble,
  LuSwissFranc,
  LuCalculator,
  LuPercent,
  LuScale,
  LuChartBar,

  // People / Users
  LuUsers,
  LuUsersRound,
  LuUser,
  LuUserCheck,
  LuUserMinus,
  LuUserPen,
  LuUserPlus,
  LuUserRound,
  LuUserRoundCheck,
  LuUserRoundCog,
  LuUserRoundMinus,
  LuUserRoundPen,
  LuUserRoundPlus,
  LuUserRoundSearch,
  LuUserRoundX,
  LuUserSearch,
  LuUserX,
  LuHandshake,
  LuGift,

  // Status / Badges
  LuBadgeCheck,
  LuBadgeHelp,
  LuBadgeInfo,
  LuBadgeX,
  LuCircleCheck,
  LuCircleCheckBig,
  LuCircleDashed,
  LuCircleDot,
  LuCircleEllipsis,
  LuCircleEqual,
  LuCircleFadingPlus,
  LuCircleGauge,
  LuCircleMinus,
  LuCirclePlay,
  LuCirclePlus,
  LuCirclePower,
  LuCircleSlash,
  LuCircleStop,
  LuCircleX,
  LuCircleAlert,
  LuInfo,
  LuCircleHelp,
  LuSparkles,
  LuStar,
  LuHeart,
  LuRocket,
  LuLightbulb,
  LuRefreshCw,

  // Time
  LuCalendar,
  LuCalendarDays,
  LuCalendarClock,
  LuCalendarCog,
  LuCalendarHeart,
  LuCalendarMinus,
  LuCalendarOff,
  LuCalendarPlus,
  LuCalendarRange,
  LuCalendarSearch,
  LuCalendarSync,
  LuCalendarX,
  LuClock,
  LuClockAlert,
  LuHistory,

  // Navigation
  LuGlobe,
  LuLink,
  LuExternalLink,
  LuArrowRight,
  LuMap,
  LuMapPin,
  LuMapPinCheck,
  LuMapPinCheckInside,
  LuMapPinHouse,
  LuMapPinMinus,
  LuMapPinMinusInside,
  LuMapPinOff,
  LuMapPinPlus,
  LuMapPinPlusInside,
  LuMapPinX,
  LuMapPinXInside,
  LuMapPinned,
  LuSearch,
  LuLogOut,

  // Tools & Security
  LuSettings,
  LuSettings2,
  LuWrench,
  LuShield,
  LuShieldAlert,
  LuShieldBan,
  LuShieldCheck,
  LuShieldEllipsis,
  LuShieldHalf,
  LuShieldMinus,
  LuShieldOff,
  LuShieldPlus,
  LuShieldQuestion,
  LuShieldX,
  LuLock,
  LuTag,
  LuLayoutDashboard,
  LuLinkedin,
  LuTwitter,
} from 'react-icons/lu';

import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
  FaGithub,
  FaTelegram,
  FaQuestionCircle,
  FaCog,
  FaUser,
  FaFolder,
  FaCheckCircle,
  FaLock,
  FaReceipt,
  FaMoneyBillWave,
  FaEnvelope,
} from 'react-icons/fa';

export const PORTAL_ICON_OPTIONS = [
  // Notifications
  { value: 'LuBell', label: 'Notification', category: 'Notifications', Icon: LuBell },
  { value: 'LuBellRing', label: 'Notification Ringing', category: 'Notifications', Icon: LuBellRing },
  { value: 'LuBellDot', label: 'Notification Dot', category: 'Notifications', Icon: LuBellDot },
  { value: 'LuMessageSquare', label: 'Chat / Message', category: 'Notifications', Icon: LuMessageSquare },
  { value: 'LuMessageSquareCode', label: 'Message Code', category: 'Notifications', Icon: LuMessageSquareCode },
  { value: 'LuMessageCircle', label: 'Message Circle', category: 'Notifications', Icon: LuMessageCircle },
  { value: 'LuMessageCircleMore', label: 'Message Circle More', category: 'Notifications', Icon: LuMessageCircleMore },
  { value: 'LuMail', label: 'Email', category: 'Notifications', Icon: LuMail },
  { value: 'LuMailOpen', label: 'Email Open', category: 'Notifications', Icon: LuMailOpen },
  { value: 'LuMailbox', label: 'Mailbox', category: 'Notifications', Icon: LuMailbox },
  { value: 'LuPhone', label: 'Phone', category: 'Notifications', Icon: LuPhone },
  { value: 'LuVideo', label: 'Video / Meeting', category: 'Notifications', Icon: LuVideo },
  { value: 'LuRss', label: 'RSS / Feed', category: 'Notifications', Icon: LuRss },

  // Documents
  { value: 'LuBookOpen', label: 'Book / Guide', category: 'Documents', Icon: LuBookOpen },
  { value: 'LuFileText', label: 'Document Text', category: 'Documents', Icon: LuFileText },
  { value: 'LuFile', label: 'File Generic', category: 'Documents', Icon: LuFile },
  { value: 'LuFileArchive', label: 'File Zip / Archive', category: 'Documents', Icon: LuFileArchive },
  { value: 'LuFileAudio', label: 'File Audio', category: 'Documents', Icon: LuFileAudio },
  { value: 'LuFileCode', label: 'File Code', category: 'Documents', Icon: LuFileCode },
  { value: 'LuFileCode2', label: 'File Code 2', category: 'Documents', Icon: LuFileCode2 },
  { value: 'LuFileSpreadsheet', label: 'Excel / Sheet', category: 'Documents', Icon: LuFileSpreadsheet },
  { value: 'LuFileWarning', label: 'File Warning', category: 'Documents', Icon: LuFileWarning },
  { value: 'LuFileX', label: 'File Cancel / X', category: 'Documents', Icon: LuFileX },
  { value: 'LuFolderOpen', label: 'Folder Open', category: 'Documents', Icon: LuFolderOpen },
  { value: 'LuFolderArchive', label: 'Folder Zip', category: 'Documents', Icon: LuFolderArchive },
  { value: 'LuFolderCheck', label: 'Folder Completed', category: 'Documents', Icon: LuFolderCheck },
  { value: 'LuFolderClock', label: 'Folder History', category: 'Documents', Icon: LuFolderClock },
  { value: 'LuFolderClosed', label: 'Folder Closed', category: 'Documents', Icon: LuFolderClosed },
  { value: 'LuFolderCog', label: 'Folder Settings', category: 'Documents', Icon: LuFolderCog },
  { value: 'LuFolderDot', label: 'Folder Alert', category: 'Documents', Icon: LuFolderDot },
  { value: 'LuFolderDown', label: 'Folder Download', category: 'Documents', Icon: LuFolderDown },
  { value: 'LuFolderGit', label: 'Folder Git', category: 'Documents', Icon: LuFolderGit },
  { value: 'LuFolderHeart', label: 'Folder Favorite', category: 'Documents', Icon: LuFolderHeart },
  { value: 'LuFolderInput', label: 'Folder Upload', category: 'Documents', Icon: LuFolderInput },
  { value: 'LuFolderKey', label: 'Folder Protected', category: 'Documents', Icon: LuFolderKey },
  { value: 'LuFolderLock', label: 'Folder Locked', category: 'Documents', Icon: LuFolderLock },
  { value: 'LuFolderMinus', label: 'Folder Remove', category: 'Documents', Icon: LuFolderMinus },
  { value: 'LuFolderOutput', label: 'Folder Export', category: 'Documents', Icon: LuFolderOutput },
  { value: 'LuFolderPen', label: 'Folder Edit', category: 'Documents', Icon: LuFolderPen },
  { value: 'LuFolderPlus', label: 'Folder Add', category: 'Documents', Icon: LuFolderPlus },
  { value: 'LuFolderRoot', label: 'Folder Root', category: 'Documents', Icon: LuFolderRoot },
  { value: 'LuFolderSearch', label: 'Folder Search', category: 'Documents', Icon: LuFolderSearch },
  { value: 'LuFolderSymlink', label: 'Folder Shortcut', category: 'Documents', Icon: LuFolderSymlink },
  { value: 'LuFolderSync', label: 'Folder Sync', category: 'Documents', Icon: LuFolderSync },
  { value: 'LuFolderTree', label: 'Folder Directory Tree', category: 'Documents', Icon: LuFolderTree },
  { value: 'LuFolderUp', label: 'Folder Upload Direct', category: 'Documents', Icon: LuFolderUp },
  { value: 'LuFolderX', label: 'Folder Error', category: 'Documents', Icon: LuFolderX },
  { value: 'LuClipboardCheck', label: 'Checklist', category: 'Documents', Icon: LuClipboardCheck },
  { value: 'LuClipboardList', label: 'List', category: 'Documents', Icon: LuClipboardList },
  { value: 'LuDownload', label: 'Download', category: 'Documents', Icon: LuDownload },
  { value: 'LuUpload', label: 'Upload', category: 'Documents', Icon: LuUpload },
  { value: 'LuNewspaper', label: 'News / Blog', category: 'Documents', Icon: LuNewspaper },
  { value: 'LuImage', label: 'Image', category: 'Documents', Icon: LuImage },
  { value: 'LuSignature', label: 'Signature / Contract', category: 'Documents', Icon: LuSignature },

  // Business
  { value: 'LuCreditCard', label: 'Payment / Credit Card', category: 'Business', Icon: LuCreditCard },
  { value: 'LuWallet', label: 'Wallet', category: 'Business', Icon: LuWallet },
  { value: 'LuReceipt', label: 'Receipt / Invoice', category: 'Business', Icon: LuReceipt },
  { value: 'LuBriefcase', label: 'Business Generic', category: 'Business', Icon: LuBriefcase },
  { value: 'LuBriefcaseBusiness', label: 'Business Corporate', category: 'Business', Icon: LuBriefcaseBusiness },
  { value: 'LuBriefcaseMedical', label: 'Business Medical', category: 'Business', Icon: LuBriefcaseMedical },
  { value: 'LuBuilding', label: 'Company / Office', category: 'Business', Icon: LuBuilding },
  { value: 'LuBuilding2', label: 'Formation / Office Large', category: 'Business', Icon: LuBuilding2 },
  { value: 'LuLandmark', label: 'Bank / Legal', category: 'Business', Icon: LuLandmark },
  { value: 'LuTrendingUp', label: 'Growth / Scaling', category: 'Business', Icon: LuTrendingUp },
  { value: 'LuTrendingDown', label: 'Decrease', category: 'Business', Icon: LuTrendingDown },
  { value: 'LuBadgeDollarSign', label: 'Badge Dollar', category: 'Business', Icon: LuBadgeDollarSign },
  { value: 'LuBadgePercent', label: 'Badge Discount', category: 'Business', Icon: LuBadgePercent },
  { value: 'LuBanknote', label: 'Banknote Cash', category: 'Business', Icon: LuBanknote },
  { value: 'LuCoins', label: 'Coins', category: 'Business', Icon: LuCoins },
  { value: 'LuDollarSign', label: 'Dollar Cash', category: 'Business', Icon: LuDollarSign },
  { value: 'LuEuro', label: 'Euro Cash', category: 'Business', Icon: LuEuro },
  { value: 'LuIndianRupee', label: 'Indian Rupee Cash', category: 'Business', Icon: LuIndianRupee },
  { value: 'LuJapaneseYen', label: 'Yen Cash', category: 'Business', Icon: LuJapaneseYen },
  { value: 'LuPoundSterling', label: 'Pound Cash', category: 'Business', Icon: LuPoundSterling },
  { value: 'LuRussianRuble', label: 'Ruble Cash', category: 'Business', Icon: LuRussianRuble },
  { value: 'LuSwissFranc', label: 'Swiss Franc Cash', category: 'Business', Icon: LuSwissFranc },
  { value: 'LuCalculator', label: 'Calculator / Accounting', category: 'Business', Icon: LuCalculator },
  { value: 'LuPercent', label: 'Discount / Promo', category: 'Business', Icon: LuPercent },
  { value: 'LuScale', label: 'Compliance / Legal', category: 'Business', Icon: LuScale },
  { value: 'LuChartBar', label: 'Analytics / Charts', category: 'Business', Icon: LuChartBar },

  // People
  { value: 'LuUsers', label: 'Team', category: 'People', Icon: LuUsers },
  { value: 'LuUsersRound', label: 'Team Rounded', category: 'People', Icon: LuUsersRound },
  { value: 'LuUser', label: 'User', category: 'People', Icon: LuUser },
  { value: 'LuUserCheck', label: 'Verified User', category: 'People', Icon: LuUserCheck },
  { value: 'LuUserMinus', label: 'Remove User', category: 'People', Icon: LuUserMinus },
  { value: 'LuUserPen', label: 'Edit User', category: 'People', Icon: LuUserPen },
  { value: 'LuUserPlus', label: 'Add User', category: 'People', Icon: LuUserPlus },
  { value: 'LuUserRound', label: 'User Round', category: 'People', Icon: LuUserRound },
  { value: 'LuUserRoundCheck', label: 'Verified User Round', category: 'People', Icon: LuUserRoundCheck },
  { value: 'LuUserRoundCog', label: 'User Settings Round', category: 'People', Icon: LuUserRoundCog },
  { value: 'LuUserRoundMinus', label: 'Remove User Round', category: 'People', Icon: LuUserRoundMinus },
  { value: 'LuUserRoundPen', label: 'Edit User Round', category: 'People', Icon: LuUserRoundPen },
  { value: 'LuUserRoundPlus', label: 'Add User Round', category: 'People', Icon: LuUserRoundPlus },
  { value: 'LuUserRoundSearch', label: 'Search User Round', category: 'People', Icon: LuUserRoundSearch },
  { value: 'LuUserRoundX', label: 'Block User Round', category: 'People', Icon: LuUserRoundX },
  { value: 'LuUserSearch', label: 'Search User', category: 'People', Icon: LuUserSearch },
  { value: 'LuUserX', label: 'Block User', category: 'People', Icon: LuUserX },
  { value: 'LuHandshake', label: 'Partnership', category: 'People', Icon: LuHandshake },
  { value: 'LuGift', label: 'Referral / Gift', category: 'People', Icon: LuGift },

  // Status
  { value: 'LuBadgeCheck', label: 'Verified Badge', category: 'Status', Icon: LuBadgeCheck },
  { value: 'LuBadgeHelp', label: 'Help Badge', category: 'Status', Icon: LuBadgeHelp },
  { value: 'LuBadgeInfo', label: 'Info Badge', category: 'Status', Icon: LuBadgeInfo },
  { value: 'LuBadgeX', label: 'Cancel Badge', category: 'Status', Icon: LuBadgeX },
  { value: 'LuCircleCheck', label: 'Success Circle', category: 'Status', Icon: LuCircleCheck },
  { value: 'LuCircleCheckBig', label: 'Success Circle Large', category: 'Status', Icon: LuCircleCheckBig },
  { value: 'LuCircleDashed', label: 'Dashed Circle', category: 'Status', Icon: LuCircleDashed },
  { value: 'LuCircleDot', label: 'Dot Circle', category: 'Status', Icon: LuCircleDot },
  { value: 'LuCircleEllipsis', label: 'More Status Circle', category: 'Status', Icon: LuCircleEllipsis },
  { value: 'LuCircleEqual', label: 'Equal Status Circle', category: 'Status', Icon: LuCircleEqual },
  { value: 'LuCircleFadingPlus', label: 'Fading Add Circle', category: 'Status', Icon: LuCircleFadingPlus },
  { value: 'LuCircleGauge', label: 'Gauge Status Circle', category: 'Status', Icon: LuCircleGauge },
  { value: 'LuCircleMinus', label: 'Minus Circle', category: 'Status', Icon: LuCircleMinus },
  { value: 'LuCirclePlay', label: 'Play Status Circle', category: 'Status', Icon: LuCirclePlay },
  { value: 'LuCirclePlus', label: 'Add Circle', category: 'Status', Icon: LuCirclePlus },
  { value: 'LuCirclePower', label: 'Power Status Circle', category: 'Status', Icon: LuCirclePower },
  { value: 'LuCircleSlash', label: 'Slash Status Circle', category: 'Status', Icon: LuCircleSlash },
  { value: 'LuCircleStop', label: 'Stop Status Circle', category: 'Status', Icon: LuCircleStop },
  { value: 'LuCircleX', label: 'Cancel Circle', category: 'Status', Icon: LuCircleX },
  { value: 'LuCircleAlert', label: 'Alert Warning Circle', category: 'Status', Icon: LuCircleAlert },
  { value: 'LuInfo', label: 'Information', category: 'Status', Icon: LuInfo },
  { value: 'LuCircleHelp', label: 'Help Circle', category: 'Status', Icon: LuCircleHelp },
  { value: 'LuSparkles', label: 'Highlight Sparkles', category: 'Status', Icon: LuSparkles },
  { value: 'LuStar', label: 'Star / Rating', category: 'Status', Icon: LuStar },
  { value: 'LuHeart', label: 'Favorite Heart', category: 'Status', Icon: LuHeart },
  { value: 'LuRocket', label: 'Launch / Start', category: 'Status', Icon: LuRocket },
  { value: 'LuLightbulb', label: 'Idea / Tip', category: 'Status', Icon: LuLightbulb },
  { value: 'LuRefreshCw', label: 'Refresh / Updates', category: 'Status', Icon: LuRefreshCw },

  // Time
  { value: 'LuCalendar', label: 'Calendar Generic', category: 'Time', Icon: LuCalendar },
  { value: 'LuCalendarDays', label: 'Calendar Schedule', category: 'Time', Icon: LuCalendarDays },
  { value: 'LuCalendarClock', label: 'Calendar Clock', category: 'Time', Icon: LuCalendarClock },
  { value: 'LuCalendarCog', label: 'Calendar Settings', category: 'Time', Icon: LuCalendarCog },
  { value: 'LuCalendarHeart', label: 'Calendar Event Heart', category: 'Time', Icon: LuCalendarHeart },
  { value: 'LuCalendarMinus', label: 'Calendar Event Remove', category: 'Time', Icon: LuCalendarMinus },
  { value: 'LuCalendarOff', label: 'Calendar Disabled', category: 'Time', Icon: LuCalendarOff },
  { value: 'LuCalendarPlus', label: 'Calendar Event Add', category: 'Time', Icon: LuCalendarPlus },
  { value: 'LuCalendarRange', label: 'Calendar Date Range', category: 'Time', Icon: LuCalendarRange },
  { value: 'LuCalendarSearch', label: 'Calendar Search Event', category: 'Time', Icon: LuCalendarSearch },
  { value: 'LuCalendarSync', label: 'Calendar Event Sync', category: 'Time', Icon: LuCalendarSync },
  { value: 'LuCalendarX', label: 'Calendar Cancelled Event', category: 'Time', Icon: LuCalendarX },
  { value: 'LuClock', label: 'Clock Generic', category: 'Time', Icon: LuClock },
  { value: 'LuClockAlert', label: 'Clock Deadline Alert', category: 'Time', Icon: LuClockAlert },
  { value: 'LuHistory', label: 'History / Logs', category: 'Time', Icon: LuHistory },

  // Navigation
  { value: 'LuGlobe', label: 'Global / Web', category: 'Navigation', Icon: LuGlobe },
  { value: 'LuLink', label: 'Link URL', category: 'Navigation', Icon: LuLink },
  { value: 'LuExternalLink', label: 'External Page Link', category: 'Navigation', Icon: LuExternalLink },
  { value: 'LuArrowRight', label: 'Arrow Next', category: 'Navigation', Icon: LuArrowRight },
  { value: 'LuMap', label: 'Map Overview', category: 'Navigation', Icon: LuMap },
  { value: 'LuMapPin', label: 'Location Map Pin', category: 'Navigation', Icon: LuMapPin },
  { value: 'LuMapPinCheck', label: 'Map Pin Approved', category: 'Navigation', Icon: LuMapPinCheck },
  { value: 'LuMapPinCheckInside', label: 'Map Pin Approved Inside', category: 'Navigation', Icon: LuMapPinCheckInside },
  { value: 'LuMapPinHouse', label: 'Address Map Pin', category: 'Navigation', Icon: LuMapPinHouse },
  { value: 'LuMapPinMinus', label: 'Map Pin Removed', category: 'Navigation', Icon: LuMapPinMinus },
  { value: 'LuMapPinMinusInside', label: 'Map Pin Removed Inside', category: 'Navigation', Icon: LuMapPinMinusInside },
  { value: 'LuMapPinOff', label: 'Map Pin Disabled', category: 'Navigation', Icon: LuMapPinOff },
  { value: 'LuMapPinPlus', label: 'Map Pin Added', category: 'Navigation', Icon: LuMapPinPlus },
  { value: 'LuMapPinPlusInside', label: 'Map Pin Added Inside', category: 'Navigation', Icon: LuMapPinPlusInside },
  { value: 'LuMapPinX', label: 'Map Pin Error', category: 'Navigation', Icon: LuMapPinX },
  { value: 'LuMapPinXInside', label: 'Map Pin Error Inside', category: 'Navigation', Icon: LuMapPinXInside },
  { value: 'LuMapPinned', label: 'Pinned Address Map', category: 'Navigation', Icon: LuMapPinned },
  { value: 'LuSearch', label: 'Search Icon', category: 'Navigation', Icon: LuSearch },
  { value: 'LuLogOut', label: 'Logout / Exit', category: 'Navigation', Icon: LuLogOut },

  // Tools & Security
  { value: 'LuSettings', label: 'Settings Gear', category: 'Tools', Icon: LuSettings },
  { value: 'LuSettings2', label: 'Settings Customizer', category: 'Tools', Icon: LuSettings2 },
  { value: 'LuWrench', label: 'Tools Wrench', category: 'Tools', Icon: LuWrench },
  { value: 'LuShield', label: 'Security Shield', category: 'Tools', Icon: LuShield },
  { value: 'LuShieldAlert', label: 'Security Alert', category: 'Tools', Icon: LuShieldAlert },
  { value: 'LuShieldBan', label: 'Security Blocked', category: 'Tools', Icon: LuShieldBan },
  { value: 'LuShieldCheck', label: 'Security Verified / Agent', category: 'Tools', Icon: LuShieldCheck },
  { value: 'LuShieldEllipsis', label: 'Security Status', category: 'Tools', Icon: LuShieldEllipsis },
  { value: 'LuShieldHalf', label: 'Security Semi', category: 'Tools', Icon: LuShieldHalf },
  { value: 'LuShieldMinus', label: 'Security Weakened', category: 'Tools', Icon: LuShieldMinus },
  { value: 'LuShieldOff', label: 'Security Disabled', category: 'Tools', Icon: LuShieldOff },
  { value: 'LuShieldPlus', label: 'Security Added', category: 'Tools', Icon: LuShieldPlus },
  { value: 'LuShieldQuestion', label: 'Security Query', category: 'Tools', Icon: LuShieldQuestion },
  { value: 'LuShieldX', label: 'Security Breached', category: 'Tools', Icon: LuShieldX },
  { value: 'LuLock', label: 'Lock Private', category: 'Tools', Icon: LuLock },
  { value: 'LuTag', label: 'Tag / Pricing', category: 'Tools', Icon: LuTag },
  { value: 'LuLayoutDashboard', label: 'Dashboard Grid', category: 'Tools', Icon: LuLayoutDashboard },

  // Socials
  { value: 'LuLinkedin', label: 'LinkedIn', category: 'Social Media', Icon: LuLinkedin },
  { value: 'LuTwitter', label: 'X / Twitter', category: 'Social Media', Icon: LuTwitter },
  { value: 'FaFacebook', label: 'Facebook', category: 'Social Media', Icon: FaFacebook },
  { value: 'FaInstagram', label: 'Instagram', category: 'Social Media', Icon: FaInstagram },
  { value: 'FaYoutube', label: 'YouTube', category: 'Social Media', Icon: FaYoutube },
  { value: 'FaWhatsapp', label: 'WhatsApp', category: 'Social Media', Icon: FaWhatsapp },
  { value: 'FaGithub', label: 'GitHub', category: 'Social Media', Icon: FaGithub },
  { value: 'FaTelegram', label: 'Telegram', category: 'Social Media', Icon: FaTelegram },

  // Help page legacy support
  { value: 'FaQuestionCircle', label: 'Help / FAQ', category: 'Help Page', Icon: FaQuestionCircle },
  { value: 'FaCog', label: 'Settings Legacy', category: 'Help Page', Icon: FaCog },
  { value: 'FaUser', label: 'Profile Legacy', category: 'Help Page', Icon: FaUser },
  { value: 'FaFolder', label: 'Documents Folder Legacy', category: 'Help Page', Icon: FaFolder },
  { value: 'FaCheckCircle', label: 'Active Check Legacy', category: 'Help Page', Icon: FaCheckCircle },
  { value: 'FaLock', label: 'Locked Legacy', category: 'Help Page', Icon: FaLock },
  { value: 'FaReceipt', label: 'Receipt Legacy', category: 'Help Page', Icon: FaReceipt },
  { value: 'FaMoneyBillWave', label: 'Payments Legacy', category: 'Help Page', Icon: FaMoneyBillWave },
  { value: 'FaEnvelope', label: 'Email Legacy', category: 'Help Page', Icon: FaEnvelope },
];

export const PORTAL_ICON_MAP = Object.fromEntries(
  PORTAL_ICON_OPTIONS.map(({ value, Icon }) => [value, Icon])
);

export const getPortalIconByName = (name) => PORTAL_ICON_MAP[name] || LuFileText;

export const getPortalIconLabel = (name) =>
  PORTAL_ICON_OPTIONS.find((opt) => opt.value === name)?.label || name || 'Document';

export const PORTAL_ICON_CATEGORIES = [...new Set(PORTAL_ICON_OPTIONS.map((opt) => opt.category))];
